<template>
    <v-select 
       :value="selected_slot" 
       v-bind:items="slots"
       item-value="code" 
       item-text="description" 
       :label="label"
       dense :clearable="isClearable"
       @change="updateData">
    </v-select>
</template>

<script>
export default {
    props: {
        selected_slot: String,
        label: {
            type: String,
            default: 'Timing'
        },    
        field: {
            default: 'slot',
            required: true,
        },
        isClearable:{
            type: Boolean,
            default: false
        }, 
    },  
    data() {
        return {
            slots: [],
        }
    },
    created() {
        this.getTimeSlots();
    },    
    methods: {
        getTimeSlots() {
            this.$axios
                .post("ares/json/ares/huov/hokl/getTimeSlots.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getTimeSlots"
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        this.showDialog('error', 'Error', res.data.error.message);
                    } else {                        
                        this.slots = res.data.getTimeSlots;
                    }
                })
        },        
        updateData(v){
            this.$emit('updateData', { "field": this.field, "value": v === null ? '' : v })
        }
    }
}

</script>